module.exports = __webpack_public_path__ + "img/cbgjzs.8bf073a4.png";